import React from "react";
import "./Contact.css";

export default function Contact() {
  const formUrl = "https://forms.gle/your-google-form-link";

  return (
    <section id="contact" className="contact-section">
      <div className="contact-wrapper container">
        <div className="contact-header">
          <h2>Get in Touch With Us</h2>
          <p className="contact-subtitle">
            Have a project in mind? We&apos;d love to hear from you. Send us a
            message and we&apos;ll get back to you as soon as possible.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-form-wrapper">
            <h3>Send us a Message</h3>
            <p className="contact-form-text">
              Fill out our quick Google Form and we&apos;ll get back to you
              within one business day.
            </p>
            <a
              href={formUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-form-btn"
            >
              Open Google Form
            </a>
          </div>

          <div className="contact-info-wrapper">
            <div className="contact-info">
              <div className="info-item">
                <div className="info-icon">📍</div>
                <div className="info-text">
                  <h4>Address</h4>
                  <p>
                    Plot No. 228, Kalwar Road
                    <br />
                    Ganesh Nagar Vistar, Jhotwara
                    <br />
                    Jaipur, Rajasthan 302012
                  </p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">📞</div>
                <div className="info-text">
                  <h4>Phone</h4>
                  <p>
                    <a href="tel:+919610071616">+91 96100 71616</a>
                  </p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">✉️</div>
                <div className="info-text">
                  <h4>Email</h4>
                  <p>
                    <a href="mailto:constructionmaabhagwati@gmail.com">
                      constructionmaabhagwati@gmail.com
                    </a>
                  </p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">🏢</div>
                <div className="info-text">
                  <h4>GST Number</h4>
                  <p>08DUAPK9144J1ZB</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
